import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Box, useTheme, useMediaQuery, Grid2, CardMedia, IconButton } from '@mui/material'
import { useState, useEffect } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import MyNumberInput from '../../../components/inputs/MyNumberInput';
import MyTextInput from '../../../components/inputs/MyTextInput';
import MyDateTimePicker from '../../../components/inputs/MyDateTimePicker';
import MyDurationInput from '../../../components/inputs/MyDurationInput';
import MySelectInput from '../../../components/inputs/MySelectInput';
import MyAutoComplete from '../../../components/inputs/MyAutoCompleteJavier';
import MyRadioGroup from '../../../components/inputs/MyRadioGroup';
import { myApi } from '../../../config/axiosConfig';
import moment from 'moment-timezone';
import Swal from 'sweetalert2';
import axios from 'axios';
import { useFormikContext } from 'formik';
import Cookies from 'js-cookie';
import { useRef } from 'react';
import DeleteIcon from "@mui/icons-material/Delete";
import { Checkbox, FormControlLabel } from '@mui/material';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";

function CrearEditarResetUsa({ open, onClose, refresh, carga, isEditing, onUpdate}) {

    const prettyPdfName = (name = "") => {
  // quita .pdf
  const base = name.replace(/\.pdf$/i, "");

  // si empieza con números + "_" típico de tus nombres, corta
  // 1772548683437_okp1lkpmygj -> okp1lkpmygj
  const cleaned = base.replace(/^\d+_?/, "");

  // si quedó vacío, usa el original
  const finalName = cleaned?.trim() ? cleaned : base;

  return `${finalName}.pdf`;
};

    const normalizarPdf = (pdf) => 
    {
        if (!pdf) return null;

        if (typeof pdf === 'object' && (pdf.nombre || pdf.ruta)) {
            return {
            id: pdf.id || null,
            nombre: pdf.nombre || (typeof pdf.ruta === 'string' ? pdf.ruta.split('/').pop() : 'Archivo.pdf'),
            ruta: pdf.ruta || null,
            file: null,
            _status: 'existing',
            };
        }

        if (typeof pdf === 'string') {
            return {
            id: null,
            nombre: pdf.split('/').pop(),
            ruta: pdf,
            file: null,
            _status: 'existing',
            };
        }

        return null;
    };

    const [resetCounter, setResetCounter] = useState(0);

    const formatDate = (date) => {
        if (!date) return ""; 

        const d = new Date(date);
        if (isNaN(d)) return "";

        const options = {
            year: '2-digit', // Año con dos dígitos
            month: '2-digit', // Mes con dos dígitos
            day: '2-digit', // Día con dos dígitos
            hour: '2-digit', // Hora con dos dígitos
            minute: '2-digit', // Minutos con dos dígitos
            second: '2-digit',    // Segundos con dos dígitos
            hour12: false, // Formato de 24 horas
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
        const [datePart, timePart] = formattedDate.split(', ');
        const [month, day, year] = datePart.split('/');
        const formattedDateTime = `${month}/${day}/${year} ${timePart}`;
    
        return formattedDateTime;
    };

    const validationSchema = Yup.object(
    {
        date: Yup.string().required('La fecha es obligatoria'),
        driver: Yup.string().required('El operador es obligatorio'),
    });

    const initialValues = 
    {
        //date: carga?.date ? moment(formatDate(carga.date), 'MM/DD/YY HH:mm').format('YYYY-MM-DD HH:mm:ss') : null,

        date: carga?.date
            ? moment(
                carga.date,
                ['YYYY-MM-DD HH:mm:ss', moment.ISO_8601],
                true
            ).format('YYYY-MM-DD HH:mm:ss')
            : null,

        driver: carga?.driver || '',

        pdf: carga?.pdf ? normalizarPdf(carga.pdf) : null,

        usuario: Cookies.get('ebt_nombre'),

        esInicial: carga?.esInicial == '1',
    };

    const [isSaving, setIsSaving] = useState(false);

    const handleSubmit = async (values, { resetForm }) => 
    {
        const formData = new FormData();

        Object.entries(values).forEach(([k, v]) => 
        {
            if (k === 'esInicial') 
            {
                formData.append('esInicial', v ? 1 : null);
            } 
            else if (k !== 'pdf') 
            {
                formData.append(k, v);
            }
        });

        if (values.pdf?._status === 'new') 
        {
            formData.append('file', values.pdf.file);
        }

        if (values.pdf?._status === 'deleted') 
        {
            formData.append('pdfEliminar', '1');
        }

        setIsSaving(true);

        try 
        {
            if (isEditing) 
            {
                let responseEditar = await myApi.put(`/cargasFuel/editarResetUsa/${carga.id}`, formData);

                if(responseEditar.data.success)
                {
                    onUpdate(responseEditar.data.data);
                    Swal.fire({
                        icon: 'success',
                        title: 'Reset editado',
                    });
                    setResetCounter(c => c + 1);
                    onClose();
                }
                else
                {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al editar reset',
                        text: responseEditar.data.data || 'Ocurrió un error desconocido',
                    });

                    console.error('Error de API:', responseEditar.data);
                }
            } 
            else 
            {
                let responseCrear = await myApi.post('/cargasFuel/crearResetUsa', formData);

                if(responseCrear.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Reset creado',
                    });
                    refresh();
                    setResetCounter(c => c + 1);
                    onClose();
                }
                else
                {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al crear reset',
                        text: responseCrear.data.data || 'Ocurrió un error desconocido',
                    });

                    console.error('Error de API:', responseCrear.data);
                }
            }
            onClose();
        } 
        catch (error) 
        {
            console.error('Error saving reset:', error);
        }
        finally { setIsSaving(false); }
    };

    const fields = 
    [
        { 
            name: 'date', 
            label: 'FECHA', 
            type: 'datetime', 
            colSpan: 1 
        },
        {
            name: 'driver',
            label: 'OPERADOR',
            type: 'autocomplete',
            colSpan: 3,
        }
    ];

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [operadores, setOperadores] = useState([]);

    const findOperadores = async () => {
        try {
            const response = await myApi.get('/fuel_report/getOperadores');

            let operadores = [];
            if (response.data.data && response.data.data.length > 0) {
                response.data.data.forEach(operador => {
                    operadores.push({ value: operador.nombre_completo, label: operador.nombre_completo });
                });
            }
            setOperadores(operadores.length > 0 ? operadores : []); 

        } catch (error) {
            console.error('Error fetching drivers:', error);
            setOperadores([]);
        }
    };

    useEffect(() => {
        findOperadores();
    }, []);

    const isEdit = isEditing && carga;

    const catalogReady =
        operadores.length > 0;

    const formReady =
        !isEdit || (isEdit && catalogReady);

    //const formReady = !isEdit;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                sx: {
                width: "100%",
                maxWidth: 520,
                }
            }}
        >
            <DialogTitle>{isEditing ? 'Editar Reset' : 'Crear Reset'}</DialogTitle>
            <DialogContent sx={{ overflowX: "hidden" }}>
                {formReady ? (
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ handleSubmit, values, touched, errors, setFieldValue }) => {

                    return (
                        <>
                        <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: isMobile
                                    ? '1fr' 
                                    : 'repeat(auto-fit, minmax(220px, 1fr))',
                                    gap: 2,
                                }}
                            >
                                {
                                    fields.map((field) => {

                                    let InputComponent;
                                    let extraProps = {};

                                    if (field.type === 'text') InputComponent = MyTextInput;
                                    else if (field.type === 'number') InputComponent = MyNumberInput;
                                    else if (field.type === 'datetime') InputComponent = MyDateTimePicker;
                                    else if (field.type === 'duration') InputComponent = MyDurationInput;
                                    else if (field.type === 'select') InputComponent = MySelectInput;
                                    else if (field.type === 'autocomplete') InputComponent = MyAutoComplete;
                                    else if (field.type === 'radio') InputComponent = MyRadioGroup;

                                    if (field.name === 'driver') 
                                    {
                                        const catalog = operadores;

                                        const initialDriver = carga?.driver;
                                        const driverToShow = values.driver || initialDriver;

                                        if (driverToShow && !catalog.some(d => d.value === driverToShow)) {
                                            extraProps.options = [...catalog, { value: driverToShow, label: driverToShow }];
                                        } else {
                                            extraProps.options = catalog;
                                        }

                                        extraProps.key = `driver-reset-${resetCounter}-${driverToShow}`;
                                    }


                                    const hasError =
                                        touched[field.name] && Boolean(errors[field.name]);

                                    return (
                                        <Box
                                        key={field.name}
                                        sx={{
                                            gridColumn: isMobile
                                            ? 'span 1'
                                            : `span ${field.colSpan || 1}`,
                                            minWidth: 0,
                                        }}
                                        >
                                        {field.type === 'radio' ? (
                                            <InputComponent
                                                name={field.name}
                                                label={field.label}
                                                options={field.options || []}
                                            />
                                            ) : (
                                            <InputComponent
                                                key={extraProps.key} 
                                                fullWidth
                                                name={field.name}
                                                label={field.label}
                                                {...(field.type === 'select' || field.type === 'autocomplete'
                                                    ? { options: field.options }
                                                    : {})}
                                                {...extraProps}
                                                error={hasError}
                                                helperText={hasError && errors[field.name]}
                                            />
                                        )}


                                        {/* SOLO PARA FECHAS */}
                                        {field.type === 'datetime' && hasError && (
                                            <div
                                            style={{
                                                color: '#D3302F',
                                                fontSize: '12px',
                                                marginTop: 4,
                                            }}
                                            >
                                            {errors[field.name]}
                                            </div>
                                        )}
                                        </Box>
                                    );
                                    })}
                                {isEditing && (
                                <Box sx={{ gridColumn: 'span 2' }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                            checked={values.esInicial}
                                            onChange={(e) =>
                                                setFieldValue('esInicial', e.target.checked)
                                            }
                                            />
                                        }
                                        label="Reset inicial"
                                    />
                                </Box>
                                )}
                            </Box>
                            {/* PDF */}
                            <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
                                <input
                                    type="file"
                                    accept="application/pdf"
                                    style={{ display: "none" }}
                                    id="upload-pdf-form"
                                    onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        setFieldValue("pdf", { id: null, nombre: file.name, file, _status: "new" });
                                    }
                                    e.target.value = null;
                                    }}
                                />

                                <label htmlFor="upload-pdf-form">
                                    <Button
                                    variant="outlined"
                                    component="span"
                                    color="secondary"
                                    sx={{
                                        px: 4,                 // padding horizontal
                                        width: "fit-content",  // no se estira
                                        minWidth: 180,         // opcional (tamaño mínimo)
                                    }}
                                    >
                                    {values.pdf && values.pdf._status !== "deleted" ? "Reemplazar PDF" : "Agregar PDF"}
                                    </Button>
                                </label>
                            </Box>
                            {values.pdf && values.pdf._status !== "deleted" && (
                            <Box sx={{ mt: 1, display: "flex", justifyContent: "center" }}>
                                <Stack direction="row" spacing={1} alignItems="center" sx={{ maxWidth: "100%" }}>
                                <Tooltip title={values.pdf.nombre}>
                                    <Chip
                                    icon={<PictureAsPdfIcon />}
                                    label={prettyPdfName(values.pdf.nombre)}
                                    variant="outlined"
                                    sx={{
                                        maxWidth: 420,         
                                        "& .MuiChip-label": {
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        display: "block",
                                        maxWidth: 330,      
                                        },
                                    }}
                                    />
                                </Tooltip>

                                <IconButton
                                    size="small"
                                    onClick={() => setFieldValue("pdf", { ...values.pdf, _status: "deleted" })}
                                    sx={{ border: "1px solid", borderColor: "divider" }}
                                >
                                    <DeleteIcon color="error" fontSize="small" />
                                </IconButton>
                                </Stack>
                            </Box>
                            )}
                            <DialogActions sx={{ justifyContent: "center", gap: 2, pt: 2 }}>
                                <Button type="submit" variant="contained" disabled={!catalogReady || isSaving}>
                                    Guardar
                                </Button>
                                <Button onClick={onClose}>Cancelar</Button>
                            </DialogActions>
                        </Form>
                        </>
                    )}}
                </Formik>
                ) : (
                    <Box sx={{ padding: 4, textAlign: 'center' }}>
                        Cargando información...
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    )
}

export default CrearEditarResetUsa